import React from "react";
import FormInput from "../../../../common/forms/FormInput";
import styles from "../EditBase.module.scss";
import { SonicTermData } from "../../../../common/classes/SonicTerm";
import SelectTerm from "../../../../common/forms/SelectTerm";
import SelectMultipleTerms from "../../../../common/forms/SelectMultipleTerms";
import { TermType } from "../../../../utils/useTerm";
import SupportSelena from "../../../../common/mypage/user-settings/SupportSelena";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ValType } from "../../../../utils/ValidationFunctions";
import EditGameDetail from "./EditGameDetail";
import { SonicGameDetailData } from "../../../../common/classes/SonicGameDetail";
import { SonicGameSelectionData } from "../../../../common/classes/SonicGameSelection";
import SonicLink from "../../../../common/routing/SonicLink";

type Props = {
  handleInputChange: (value: File | string | undefined, name: string) => void;

  img_src?: string;
  name?: string;
  kana?: string;
  player_type?: string;
  profile?: string;
  birthplace?: string;
  weight?: string;
  height?: string;
  hobby?: string;
  typeOptions?: Array<[string, string]>;
  games?: Array<SonicTermData>;
  handleGames: (value: Array<SonicTermData>) => void;
  team?: SonicTermData;
  handleTeam: (value: SonicTermData) => void;
  gameDetails?: Array<SonicGameDetailData>;
  gameDetailLoading: boolean;
  gameDetailOptions?: Array<SonicGameSelectionData>;
  handleGameDetails: (details: Array<SonicGameDetailData>) => void;
};

// TODO CSS修正
const EditProfile: React.FC<Props> = ({
  img_src,
  name,
  kana,
  player_type,
  profile,
  birthplace,
  weight,
  height,
  hobby,
  typeOptions,
  games,
  handleGames,
  team,
  handleTeam,
  handleInputChange,
  gameDetails,
  gameDetailLoading,
  gameDetailOptions,
  handleGameDetails,
}) => {
  return (
    <div className={styles["p-edit__wrapper"]}>
      <div
        className={`${styles["p-edit__wrapper__img"]} ${styles["p-edit__inner"]}`}
      >
        <div className={styles["p-edit__title"]}>
          プロフィール画像
          <div className={styles["p-edit__title-desc"]}>
            画像を設定することであなたのプロフィールがユーザーの目に留まりやすくなります。
          </div>
        </div>
        <div className={`${styles["p-edit__set-img"]} ${styles["no-bg"]}`}>
          <div className={styles["p-edit__imgbox"]}>
            {
              // This throws as error but works perfectly fine so it's fine for now
            }
            <img src={img_src} />
            <div
              className={`${styles["p-edit__form"]} ${styles["p-edit__item-center"]}`}
            >
              <FormInput
                type="file"
                // TODO=Translat
                label=""
                label_class={
                  img_src
                    ? styles["p-edit__img__label"]
                    : `${styles["p-edit__img__label"]} ${styles["p-edit__camera-icon"]}`
                }
                id="main_image"
                name="sonic_imgs"
                style_class={`${styles["image"]} ${styles["p-edit__img__input"]}`}
                handler={handleInputChange}
                val_type={ValType.File}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles["p-edit__inner"]}>
        <div className={styles["p-edit__title"]}>基本情報</div>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="text"
            label="名前"
            label_class={`${styles["p-edit__form-title"]} ${styles["required-mark"]}`}
            // id=""
            name="sonic_name"
            placeholder="ニックネームや活動名"
            style_class={styles["p-edit__form-input"]}
            handler={handleInputChange}
            initial_value={name}
            merit_text="プロフィールや一覧ページで表示されます"
            val_type={ValType.NotNull}
          />
        </div>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="text"
            label="名前(ふりがな)"
            label_class={styles["p-edit__form-title"]}
            id="kana"
            name="sonic_kana"
            placeholder="ふりがな"
            style_class={styles["p-edit__form-input"]}
            initial_value={kana}
            handler={handleInputChange}
            merit_text="やりとりがスムーズになります"
          />
        </div>
        <div className={styles["p-edit__form"]}>
          <SelectTerm
            termType={TermType.Teams}
            termName={"チーム"}
            placeholder={"所属チーム/団体を選択"}
            term={team}
            handleTerm={handleTeam}
          />
        </div>

        <div className={styles["p-edit__form"]}>
          <FormInput
            type="select"
            options={typeOptions}
            label="タイプ"
            label_class={styles["p-edit__form-title"]}
            id="player_type"
            name="sonic_player_type"
            placeholder="タイプを選択"
            select_class={styles["p-edit__form-input"]}
            holder_class={styles["p-edit__form-input-novalue"]}
            handler={handleInputChange}
            initial_value={player_type}
            merit_text="プロフィールを検索されやすくなります"
          />
          <div className={styles["p-edit__help"]}>
            <SonicLink to="/contact" newTab={true}>
              ご希望のタイプがない方はこちら
            </SonicLink>
          </div>
        </div>
        <div className={styles["p-edit__form"]}>
          <div className={styles["p-edit__form-title"]}>マイゲーム</div>
          <p>ゲームから検索されやすくなります</p>
          <EditGameDetail
            initialData={gameDetails}
            games={games}
            isLoading={gameDetailLoading}
            gameSelectionOptions={gameDetailOptions ? gameDetailOptions : []}
            handleGameDetails={handleGameDetails}
          />
          <SelectMultipleTerms
            termType={TermType.Games}
            termName={"ゲーム"}
            buttonText={"マイゲームを選ぶ"}
            terms={games ? games : []}
            handleTerms={handleGames}
          />
          <div className={styles["p-edit__help"]}>
            <SonicLink to="/contact" newTab={true}>
              {"ご希望のゲームがない方はこちら"}
            </SonicLink>
          </div>
        </div>

        <div className={styles["p-edit__form"]}>
          <FormInput
            type="textarea"
            label="自己紹介"
            label_class={styles["p-edit__form-title"]}
            id="profile"
            name="sonic_profile"
            placeholder={`記入例:\n
プロフィールご覧いただきありがとうございます。\n
フリーのイラストレーター/デザイナーとしてロゴ作成やフライヤーデザインなどをやってます。\n
ゲーム配信を見ることが多いので、eスポーツにマッチしたデザインは得意です。\n\n
■使用可能ツール：【Illustrator】【Photoshop】【InDesign】【Canva】など\n\n
好きなゲームは○○○○と◇◇◇です。プレイ時間は△△時間くらいで上手くは無いですが楽しくやってます！\n
ご興味持っていただけましたらオファーでお気軽にお声がけください。よろしくお願いします。`}
            style_class={styles["p-edit__form-input"]}
            rows={12}
            handler={handleInputChange}
            initial_value={profile}
            merit_text="あなたのアピールできること、得意なこと、できる仕事、好きなことなどを記入しましょう。"
          />
          <SupportSelena support_text="プロフィールはたくさんの人に公開されます。入力内容は慎重にご検討ください。詳しくは下記リンクをご覧ください。" />

          <div className={styles["p-edit__support-link"]}>
            <SonicLink to="/info/terms-persons" newTab={true}>
              利用規約はこちら
              <FontAwesomeIcon icon={["fal", "external-link-alt"]} />
            </SonicLink>
          </div>
        </div>
        <div className={styles["p-edit__title"]}>
          詳細情報
          <div className={styles["p-edit__title-desc"]}>
            以下の項目は任意入力となっております。未入力の項目は公開されません。
          </div>
        </div>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="text"
            label="出身地"
            label_class={styles["p-edit__form-title"]}
            id="birthplace"
            name="sonic_birthplace"
            placeholder="出身地"
            style_class={styles["p-edit__form-input"]}
            handler={handleInputChange}
            initial_value={birthplace}
          />
        </div>
        <div className={styles["p-edit__wrapper-half"]}>
          <div className={`${styles["p-edit__form"]} ${styles["half"]}`}>
            <FormInput
              type="text"
              label="身長"
              label_class={styles["p-edit__form-title"]}
              id="height"
              name="sonic_height"
              placeholder="- -"
              style_class={styles["p-edit__form-input"]}
              handler={handleInputChange}
              initial_value={height}
            />
            cm
          </div>
          <div className={`${styles["p-edit__form"]} ${styles["half"]}`}>
            <FormInput
              type="text"
              label="体重"
              label_class={styles["p-edit__form-title"]}
              id="weight"
              name="sonic_weight"
              placeholder="- - -"
              style_class={styles["p-edit__form-input"]}
              handler={handleInputChange}
              initial_value={weight}
            />
            kg
          </div>
        </div>
        <div className={styles["p-edit__form"]}>
          <FormInput
            type="textarea"
            label="趣味"
            label_class={styles["p-edit__form-title"]}
            id="hobby"
            name="sonic_hobby"
            placeholder="趣味"
            style_class={styles["p-edit__form-input"]}
            rows={8}
            handler={handleInputChange}
            initial_value={hobby}
          />
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
